import { createApi } from "@reduxjs/toolkit/query/react";
import { sharedBaseQuery } from "../../api/baseQuery";

export type OperationType = "CREATE" | "UPDATE" | "DELETE";

export interface DeviceOperationLog {
  id: string;
  device_id: string;
  device_name?: string;
  device_type?: string;
  operation_type: OperationType;
  operation_timestamp: string;
  operator_name?: string;
  operator_ip?: string;
  changed_fields?: any;
  data_before?: any;
  data_after?: any;
  operation_reason?: string;
  project_id?: number;
}

export interface DeviceLogsResponse {
  logs: DeviceOperationLog[];
  total: number;
}

interface DeviceLogQuery {
  deviceId?: string;
  operationType?: string;
  startDate?: string;
  endDate?: string;
  projectId?: number;
  operatorName?: string;
  limit?: number;
  offset?: number;
}

export const deviceLogsApi = createApi({
  reducerPath: "deviceLogsApi",
  baseQuery: sharedBaseQuery.baseQueryWithReauth,
  tagTypes: ["DeviceLog"],
  endpoints: (builder) => ({
    getDeviceLogs: builder.query<DeviceLogsResponse, DeviceLogQuery>({
      query: (params) => {
        const sp = new URLSearchParams();
        Object.entries(params).forEach(([k, v]) => {
          if (v != null && v !== "") sp.append(k, String(v));
        });
        return { url: `device-logs?${sp.toString()}` };
      },
      providesTags: ["DeviceLog"],
    }),
    getRecentDeviceLogs: builder.query<
      DeviceOperationLog[],
      { deviceId: string; limit?: number }
    >({
      query: ({ deviceId, limit = 20 }) => ({
        url: `device-logs/device/${deviceId}/recent?limit=${limit}`,
      }),
      providesTags: ["DeviceLog"],
    }),
    getDeviceLogStats: builder.query<any, { deviceId?: string }>({
      query: ({ deviceId }) => {
        const sp = new URLSearchParams();
        if (deviceId) sp.append("deviceId", deviceId);
        return { url: `device-logs/stats?${sp.toString()}` };
      },
    }),
  }),
});

export const {
  useGetDeviceLogsQuery,
  useGetRecentDeviceLogsQuery,
  useGetDeviceLogStatsQuery,
} = deviceLogsApi;
